import { useMediaQuery, useTheme } from '@mui/material';

export default function useResponsive() {
  const theme = useTheme();
  const lessThanMd = useMediaQuery(theme.breakpoints.down('md'));
  const isMobile =
    window.screen.orientation.type === 'portrait-primary' ||
    window.screen.orientation.type === 'portrait-secondary' ||
    lessThanMd;
  return { isMobile };
}
